<template>
  <v-app :dark="$vuetify.theme.dark">

    <!-- App Bar -->
    <v-app-bar
      app
      :color="$vuetify.theme.dark ? 'grey darken-4' : 'primary'"
      elevate-on-scroll
      :height="$vuetify.breakpoint.smAndDown ? 70 : 80"
    >
        <!-- PWA Components -->
    <InstallPrompt />
    <UpdateNotification />
      <v-container class="pa-0 fill-height">

        <!-- Logo -->
        <div
          class="d-flex align-center logo-area"
          @click="$router.push('/')"
          style="cursor: pointer"
        >
          <v-icon class="mr-2" color="primary" size="36">mdi-code-tags</v-icon>
          <span class="font-weight-bold brand-name">Codelyzer</span>
        </div>

        <v-spacer></v-spacer>

        <!-- Dark Mode Toggle -->
        <v-btn
          icon
          @click="$vuetify.theme.dark = !$vuetify.theme.dark"
          class="mr-2"
        >
          <v-icon v-if="$vuetify.theme.dark">mdi-weather-sunny</v-icon>
          <v-icon v-else>mdi-weather-night</v-icon>
        </v-btn>

 <!-- Share Menu -->
<v-menu offset-y>
  <template v-slot:activator="{ on, attrs }">
    <v-btn
      text
      large
      v-bind="attrs"
      v-on="on"
      class="hidden-sm-and-down"
    >
      <span class="mr-2">Share</span>
      <v-icon>mdi-share-variant</v-icon>
    </v-btn>
  </template>

  <v-list>

    <v-list-item @click="shareTwitter">
      <v-list-item-icon>
        <v-icon color="blue">mdi-twitter</v-icon>
      </v-list-item-icon>
      <v-list-item-title>Share on X / Twitter</v-list-item-title>
    </v-list-item>

    <v-list-item @click="shareLinkedIn">
      <v-list-item-icon>
        <v-icon color="blue darken-2">mdi-linkedin</v-icon>
      </v-list-item-icon>
      <v-list-item-title>Share on LinkedIn</v-list-item-title>
    </v-list-item>

    <v-list-item @click="shareReddit">
      <v-list-item-icon>
        <v-icon color="deep-orange">mdi-reddit</v-icon>
      </v-list-item-icon>
      <v-list-item-title>Share on Reddit</v-list-item-title>
    </v-list-item>

    <v-list-item @click="copyLink">
      <v-list-item-icon>
        <v-icon>mdi-content-copy</v-icon>
      </v-list-item-icon>
      <v-list-item-title>Copy Link</v-list-item-title>
    </v-list-item>

  </v-list>
</v-menu>


      </v-container>
    </v-app-bar>

    <v-main>
      <v-container class="px-0" fluid>

        <!-- HERO SECTION -->
        <v-container class="mt-12 mb-10">
          <v-row>
            <v-col cols="12" md="9" class="mx-auto text-center">

              <h1 class="font-weight-bold text-h4 text-md-h3">
                Understand Any Codebase in Seconds.
              </h1>

              <p class="mt-5 text-body-1">
                Codelyzer analyzes your entire project structure — including file distribution, 
                complexity, duplicate code, dependencies, language breakdown, and overall health — 
                fully in your browser.
              </p>

              <p class="mt-2 font-weight-medium">
                🔒 No uploads. No servers. No tracking. Your code never leaves your device.
              </p>

              <ul class="text-body-1 mt-6 text-left d-inline-block" style="list-style: disc; padding-left: 1.5rem;">

                <li>🟢 Project Health Score with actionable insights</li>
                <li>📊 Language analysis (Classes, Functions, File Types)</li>
                <li>🔁 Duplicate file & duplicate code detection</li>
                <li>📁 Project structure & file distribution breakdown</li>
                <li>⚡ Real-time performance timer (fast, client-side processing)</li>

              </ul>

              <p class="mt-6 text-body-2">
                Perfect for onboarding into new projects, auditing legacy code, reviewing client work,
                or understanding open-source repositories.
              </p>

              <p class="mt-4 font-weight-medium">
                ⚡ 8MB projects analyzed in ~15 seconds on older hardware.
              </p>

            </v-col>
          </v-row>
        </v-container>

        <router-view/>

      </v-container>
      <v-snackbar
  v-model="snackbar"
  :color="snackbarColor"
  top
  right
  timeout="3000"
>
  {{ snackbarMessage }}
  <template v-slot:action="{ attrs }">
    <v-btn color="white" text v-bind="attrs" @click="snackbar = false">
      Close
    </v-btn>
  </template>
</v-snackbar>

    </v-main>

    <!-- FOOTER -->
    <v-footer
      :color="$vuetify.theme.dark ? 'grey darken-4' : 'primary'"
      padless
    >
      <v-container>
        <v-row class="py-8">

          <v-col cols="12" md="6" class="text-center text-md-left">

            <h3 class="font-weight-medium mb-4">Why Codelyzer?</h3>

            <div class="mb-4">
              <v-chip
                color="success"
                class="mr-2 mb-2"
                prepend-icon="mdi-shield-lock"
                small
              >
                Privacy First
              </v-chip>

              <v-chip
                color="primary"
                class="mr-2 mb-2"
                prepend-icon="mdi-laptop"
                small
              >
                Runs 100% Locally
              </v-chip>

              <v-chip
                color="warning"
                class="mb-2"
                prepend-icon="mdi-cloud-off-outline"
                small
              >
                Zero Uploads
              </v-chip>
            </div>

            <p class="text-body-2">
              Codelyzer is a fully client-side codebase intelligence tool built for developers 
              who want instant clarity without compromising privacy.
            </p>

            <p class="text-body-2 mt-2">
              It performs deep structural analysis entirely in your browser —
              meaning there are <strong>zero network requests</strong> during analysis.
              You can even open your DevTools Network tab to verify.
            </p>

          </v-col>
<v-col cols="12" md="6" class="text-center text-md-right">

  <h3 class="font-weight-medium mb-4">Support the Project</h3>

  <p class="text-body-2">
    Codelyzer is completely free and ad-free.
    If it’s helped you understand your projects faster, consider supporting its development.
  </p>

  <v-btn
    href="https://www.buymeacoffee.com/kells4real"
    target="_blank"
    rel="noopener"
    color="warning"
    class="font-weight-bold mt-3"
  >
    ☕ Buy Me a Coffee
  </v-btn>

  <!-- 👇 Add this -->
  <div class="mt-4">
    <v-btn
      v-for="(item, i) in icons"
      :key="i"
      :href="item.link"
      target="_blank"
      rel="noopener"
      icon
      class="mx-1"
    >
      <v-icon size="22">
        {{ item.icon }}
      </v-icon>
    </v-btn>
  </div>

</v-col>


        </v-row>

        <v-divider class="primary lighten-1"></v-divider>

        <v-row class="py-4">
          <v-col cols="12" class="text-center text-body-2">
            © {{ new Date().getFullYear() }} Codelyzer — Built for Developers.
          </v-col>
        </v-row>

      </v-container>
    </v-footer>

  </v-app>
</template>

<script>
const image = require('./Edufy.png')
import InstallPrompt from '@/components/installPrompt.vue';
import UpdateNotification from '@/components/updateNotification.vue';
import pwaService from '@/services/pwaService';

export default {
  name: 'App',

    components: {
    InstallPrompt,
    UpdateNotification
  },

  data: () => ({
    icons: [
      { icon: 'mdi-facebook', link: 'https://facebook.com/sajere' },
      { icon: 'mdi-twitter', link: 'https://twitter.com/kells4real' },
      { icon: 'mdi-linkedin', link: 'https://www.linkedin.com/in/kells4real/' },
      { icon: 'mdi-instagram', link: 'https://instagram.com/kells4real' },
      { icon: 'mdi-github', link: 'https://github.com/kells4real' }
    ],
    showDebug: process.env.NODE_ENV !== 'production',
    logo: image,
    snackbar: false,
    snackbarMessage: '',
    snackbarColor: 'success',
  }),

  created() {
    // Add smooth scrolling behavior
    if (process.client) {
      document.documentElement.style.scrollBehavior = 'smooth'
    }
    
    // Initialize theme from localStorage or prefer-color-scheme
    const darkMode = localStorage.getItem('darkMode') === 'true' || 
                    (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches)
    this.$vuetify.theme.dark = darkMode
  },
methods: {
    debugInstall() {
      console.log('PWA Service State:', {
        isInstallable: pwaService.isInstallable(),
        hasPrompt: !!pwaService.deferredPrompt,
        isInstalled: pwaService.checkIfInstalled()
      });
      
      if (pwaService.isInstallable()) {
        pwaService.install();
      }
    },
  getShareText() {
    return "Understand any codebase in seconds. 100% local. No uploads. 🔒"
  },

  getShareUrl() {
    return window.location.origin
  },

  shareNative() {
    if (navigator.share) {
      navigator.share({
        title: "Codelyzer",
        text: this.getShareText(),
        url: this.getShareUrl()
      })
    } else {
      this.copyLink()
    }
  },

  shareTwitter() {
    const text = encodeURIComponent(this.getShareText())
    const url = encodeURIComponent(this.getShareUrl())
    window.open(`https://twitter.com/intent/tweet?text=${text}&url=${url}`, '_blank')
  },

  shareLinkedIn() {
    const url = encodeURIComponent(this.getShareUrl())
    window.open(`https://www.linkedin.com/sharing/share-offsite/?url=${url}`, '_blank')
  },

  shareReddit() {
    const url = encodeURIComponent(this.getShareUrl())
    const title = encodeURIComponent("Analyze your codebase entirely in your browser.")
    window.open(`https://www.reddit.com/submit?url=${url}&title=${title}`, '_blank')
  },

async copyLink() {
  try {
    await navigator.clipboard.writeText(this.getShareUrl())
    this.snackbarMessage = "Link copied to clipboard!"
    this.snackbarColor = "success"
    this.snackbar = true
  } catch (err) {
    this.snackbarMessage = "Failed to copy link."
    this.snackbarColor = "error"
    this.snackbar = true
  }
}

},

  watch: {
    '$vuetify.theme.dark'(val) {
      localStorage.setItem('darkMode', val)
    }
  }
}
</script>

<style>
/* Load font globally */
body, .v-application {
  font-family: 'Sora', sans-serif !important;
}

/* Apply 'Sora' font across all Vuetify text utility classes */
.v-application,
.text-h1, .text-h2, .text-h3, .text-h4, .text-h5, .text-h6,
.text-subtitle-1, .text-subtitle-2,
.text-body-1, .text-body-2,
.text-caption, .text-overline,
.font-weight-light, .font-weight-regular, .font-weight-medium, .font-weight-bold,
h1, h2, h3, h4, h5, h6,
p, span, li, a, strong, em, blockquote {
  font-family: 'Sora', sans-serif !important;
}
h1, h2, h3 {
  font-weight: 600;
  letter-spacing: -0.5px;
}
p {
  font-weight: 400;
  line-height: 1.6;
}
</style>
<style scoped>
/* Logo section enhancements */
.logo-area {
  transition: opacity 0.2s ease, transform 0.2s ease;
}

.logo-area:hover {
  opacity: 0.9;
  transform: scale(1.02);
}

.brand-name {
  font-family: 'Sora', sans-serif;
  letter-spacing: -0.5px;
}
/* Custom scrollbar - light mode */
::-webkit-scrollbar {
  width: 8px;
}
::-webkit-scrollbar-track {
  background: #f1f1f1;
}
::-webkit-scrollbar-thumb {
  background: #1976d2;
  border-radius: 4px;
}
::-webkit-scrollbar-thumb:hover {
  background: #1565c0;
}
.v-btn {
  text-decoration: none !important;
}

.v-btn:hover {
  text-decoration: none !important;
}
/* Custom scrollbar - dark mode */
.v-application.theme--dark ::-webkit-scrollbar-track {
  background: #121212;
}
.v-application.theme--dark ::-webkit-scrollbar-thumb {
  background: #2196F3;
}
.v-application.theme--dark ::-webkit-scrollbar-thumb:hover {
  background: #64B5F6;
}

/* Footer link hover effect */
a {
  transition: all 0.3s ease;
}
a:hover {
  opacity: 0.8;
  text-decoration: underline !important;
}

/* App bar elevation transition */
.v-app-bar {
  transition: box-shadow 0.3s ease, background-color 0.3s ease;
}

/* Footer social icons */
.v-btn--icon {
  transition: transform 0.3s ease;
}
.v-btn--icon:hover {
  transform: translateY(-3px);
}

/* Container fluid padding adjustment */
.v-container.fluid {
  padding-left: 0;
  padding-right: 0;
}

/* Smooth theme transition */
.v-application {
  transition: background-color 0.3s ease;
}
ul {
  margin: 0;
  padding-left: 1.25rem;
}

li {
  margin-bottom: 0.75rem;
  line-height: 1.6;
}

</style>